import { financeAPI } from "../../axios";

export const actions = {
    //JobCategory
    GetJournalTypes(){
        return financeAPI.get(`JournalType/All`);
    },

}